import { render, staticRenderFns } from "./AcceptedChanges.vue?vue&type=template&id=c6debd7e&scoped=true&"
import script from "./AcceptedChanges.vue?vue&type=script&lang=js&"
export * from "./AcceptedChanges.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedChanges.vue?vue&type=style&index=0&id=c6debd7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6debd7e",
  null
  
)

export default component.exports